export const orderBy = [
  {
    id: "weight",
    label: "Consigliati",
    value: {
      by: "weight",
      direction: "desc",
    },
  },
  {
    id: "minPrice",
    label: "Prezzo più basso",
    value: {
      by: "price",
      direction: "asc",
    },
  },
  {
    id: "maxPrice",
    label: "Prezzo più alto",
    value: {
      by: "price",
      direction: "desc",
    },
  },
  {
    id: "az",
    label: "Dalla A alla Z",
    value: {
      by: "alphabetically",
      direction: "asc",
    },
  },
]

export interface OrderByItem {
  by: string
  direction: string
}

export const isSelected = (value: OrderByItem, current: OrderByItem) =>
  value.by === current.by && value.direction === current.direction
